import getWindow from "./window";

export default function isScreenHoverable(): boolean {
  if (!getWindow()) {
    return false;
  }
  return getWindow().matchMedia("(hover: hover)").matches;
}
